import { atom } from "jotai";
import { atomWithQuery } from "jotai-tanstack-query";

import { authAtom } from "../../hooks/auth/atoms";
import { selectedLocationAtom } from "../../hooks/appState/useSelectedLocation";

import { loadAllCategories, loadTaggingData } from "../../apis/tagging";
import { Storage } from "../../storage";

interface BasicTaggingDataParams {
  reviewId: string | null;
  venueId: string;
  categoryId: string;
  categoryLevel: string;
  typeQuestionTagId: string;
}
export const basicTaggingDataParams = atom<BasicTaggingDataParams | null>(null);

export const basicTaggingDataAtom = atomWithQuery((get) => ({
  queryKey: ["loadBasicTaggingData", get(basicTaggingDataParams)],
  queryFn: async ({ queryKey: [, params, user] }) => {
    if (params === null) {
      return null;
    }
    const { reviewId, venueId, categoryId, categoryLevel, typeQuestionTagId } =
      params as BasicTaggingDataParams;
    const token = Storage.getCurrentUserToken() || "";
    return loadTaggingData(
      reviewId,
      venueId,
      categoryId,
      categoryLevel,
      typeQuestionTagId,
      token
    );
  },
}));

export const allCategoriesAtom = atomWithQuery((get) => ({
  queryKey: [
    "loadAllCategories",
    get(selectedLocationAtom)?.id,
    get(authAtom)?.data?.accessToken,
  ],
  queryFn: async ({ queryKey: [, venueId, accessToken] }) => {
    const categories = await loadAllCategories(
      venueId as string,
      Storage.getCurrentUserToken() || ""
    );
    return categories;
  },
}));
